<template>
  <!-- 전광판 애니메이션 -->
  <div :class="$style.marqueeContainer">
    <div v-if="thisWeekLives.length > 0" :class="$style.marqueeContent">
      <span v-for="(live, index) in thisWeekLives" :key="index" :class="$style.marqueeItem"
        @click="goToLiveDetail(live.id)" style="cursor: pointer;">
        🎵 {{ live.title }} | {{ live.date }} | {{ live.place }} |
        {{ formatLineup(live.lineup) }}
      </span>
      <span v-for="(live, index) in thisWeekLives" :key="`duplicate-${index}`" :class="$style.marqueeItem"
        @click="goToLiveDetail(live.id)" style="cursor: pointer;">
        🎵 {{ live.title }} | {{ live.date }} | {{ live.place }} |
        {{ formatLineup(live.lineup) }}
      </span>
    </div>
    <div v-else :class="$style.marqueeContent">
      <span :class="$style.marqueeItem">🎵 이번 주 예정된 라이브가 없습니다</span>
      <span :class="$style.marqueeItem">🎵 다음 주를 기대해주세요!</span>
    </div>
  </div>

  <!-- 금주의 라이브 섹션 -->
  <!-- <div v-if="thisWeekLives.length > 0" :class="$style.weeklySection"> -->
  <div v-if="false" :class="$style.weeklySection">
    <div :class="$style.weeklySectionHeader">
      <span :class="$style.weeklySectionTitle">🎤 금주의 라이브</span>
    </div>
    <div :class="$style.weeklyCardsWrapper">
      <div :class="$style.weeklyCards">
        <div v-for="live in thisWeekLives" :key="'weekly-' + live.id" :class="$style.weeklyCard"
          @click="goToDetail(live)">
          <div :class="[
            $style.weeklyImgDiv,
            { [$style.ddayGlow]: calculateDaysLeft(live.date) === 'D-DAY' },
            { [$style.linkookGlow]: live.linkookReservation && live.isReservationOpened && !live.isReservationClosed }
          ]">
            <p v-if="live.linkookReservation && live.isReservationOpened && !live.isReservationClosed"
              :class="$style.linkookLabel">링꾹예매중</p>
            <p :class="calculateDaysLeft(live.date) === 'D-DAY' ? $style.ddayLabel : $style.dayCount">
              {{ calculateDaysLeft(live.date) }}
            </p>
            <img :class="$style.liveType" :src="typeUrl(live.type)" :alt="live.type" />
            <img v-if="!live.imageError && live.imgUrl" loading="lazy" :src="live.imgUrl" :alt="live.title"
              @error="handleImageError(live)" />
            <div v-else :class="$style.weeklyImagePlaceholder">
              <div :class="$style.placeholderIcon">🎵</div>
            </div>
          </div>
          <div :class="$style.weeklyDate">{{ live.date }}</div>
          <div :class="$style.weeklyTitle">{{ live.title }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- 필터 및 검색 컨트롤 -->
  <div :class="$style.controls">
    <!-- 타입 필터 -->
    <div :class="$style.typeFilter">
      <button :class="[$style.likeButton, { [$style.activeLike]: likedOnly }]" @click="handleLikeFilterClick"
        aria-label="좋아요한 항목만 보기">
        <img :class="$style.likeIcon" src="@/assets/images/heart.png" alt="좋아요" />
      </button>
      <button
        :class="[$style.typeButton, { [$style.activeType]: !selectedTypes.vocal && !selectedTypes.band && !selectedTypes.dance && !selectedTypes.other }]"
        @click="resetTypes">
        전체
      </button>
      <button :class="[$style.typeButton, { [$style.activeType]: selectedTypes.vocal }]" @click="toggleType('vocal')">
        보컬
      </button>
      <button :class="[$style.typeButton, { [$style.activeType]: selectedTypes.band }]" @click="toggleType('band')">
        밴드
      </button>
      <button :class="[$style.typeButton, { [$style.activeType]: selectedTypes.dance }]" @click="toggleType('dance')">
        댄스
      </button>
      <button :class="[$style.typeButton, { [$style.activeType]: selectedTypes.other }]" @click="toggleType('other')">
        그 외
      </button>
      <button v-if="!userStore.isBlocked" :class="[$style.registerButton, $style.desktopOnly]" @click="openPopup">
        <img :class="$style.plusIcon" src="@/assets/images/plus.svg" alt="추가" />
        등록 신청
      </button>
    </div>

    <!-- 검색 및 정렬 -->
    <div :class="$style.sortFilter">

      <!-- 동기화 버튼 (관리자만 표시) -->
      <div :class="$style.syncButtonWrapper">
        <button :class="[$style.syncButton, { [$style.syncButtonActive]: viewMode === 'calendar' }]"
          @click="handleSync">
          <img :class="$style.syncIcon" src="@/assets/images/sync.png" alt="달력 보기" />
        </button>
      </div>

      <!-- 날짜 필터 -->
      <div :class="$style.dateFilterWrapper">
        <button :class="[$style.dateFilterButton, { [$style.dateFilterActive]: dateFilterStart || dateFilterEnd }]"
          @click="toggleDateFilter">
          <img :class="$style.calendarIcon" src="@/assets/images/calendar_month.png" alt="기간 설정" />
        </button>

        <!-- 날짜 선택 드롭다운 -->
        <div v-if="showDateFilter" :class="$style.dateFilterDropdown">
          <div :class="$style.dateFilterBody">
            <!-- 시작 년월 -->
            <div :class="$style.dateFilterRow">
              <label :class="$style.dateFilterLabel">시작</label>
              <div :class="$style.customSelect" @click="toggleDropdown('startYear')">
                <span :class="$style.customSelectText">{{ dateFilterStartYear ? dateFilterStartYear + '년' : '년도'
                }}</span>
                <span :class="$style.customSelectArrow">▼</span>
                <div v-if="openDropdown === 'startYear'" :class="$style.customSelectOptions">
                  <div :class="$style.customSelectOption" @click.stop="selectYear('start', '')">년도</div>
                  <div v-for="year in availableYears" :key="'sy-' + year"
                    :class="[$style.customSelectOption, { [$style.selected]: dateFilterStartYear === year }]"
                    @click.stop="selectYear('start', year)">{{ year }}년</div>
                </div>
              </div>
              <div :class="[$style.customSelect, { [$style.disabled]: !dateFilterStartYear }]"
                @click="dateFilterStartYear && toggleDropdown('startMonth')">
                <span :class="$style.customSelectText">{{ dateFilterStartMonth ? dateFilterStartMonth + '월' : '월'
                }}</span>
                <span :class="$style.customSelectArrow">▼</span>
                <div v-if="openDropdown === 'startMonth'" :class="$style.customSelectOptions">
                  <div :class="$style.customSelectOption" @click.stop="selectMonth('start', '')">월</div>
                  <div v-for="month in availableStartMonths" :key="'sm-' + month"
                    :class="[$style.customSelectOption, { [$style.selected]: dateFilterStartMonth === month }]"
                    @click.stop="selectMonth('start', month)">{{ month }}월</div>
                </div>
              </div>
            </div>
            <!-- 종료 년월 -->
            <div :class="$style.dateFilterRow">
              <label :class="$style.dateFilterLabel">종료</label>
              <div :class="$style.customSelect" @click="toggleDropdown('endYear')">
                <span :class="$style.customSelectText">{{ dateFilterEndYear ? dateFilterEndYear + '년' : '년도' }}</span>
                <span :class="$style.customSelectArrow">▼</span>
                <div v-if="openDropdown === 'endYear'" :class="$style.customSelectOptions">
                  <div :class="$style.customSelectOption" @click.stop="selectYear('end', '')">년도</div>
                  <div v-for="year in availableEndYears" :key="'ey-' + year"
                    :class="[$style.customSelectOption, { [$style.selected]: dateFilterEndYear === year }]"
                    @click.stop="selectYear('end', year)">{{ year }}년</div>
                </div>
              </div>
              <div :class="[$style.customSelect, { [$style.disabled]: !dateFilterEndYear }]"
                @click="dateFilterEndYear && toggleDropdown('endMonth')">
                <span :class="$style.customSelectText">{{ dateFilterEndMonth ? dateFilterEndMonth + '월' : '월' }}</span>
                <span :class="$style.customSelectArrow">▼</span>
                <div v-if="openDropdown === 'endMonth'" :class="$style.customSelectOptions">
                  <div :class="$style.customSelectOption" @click.stop="selectMonth('end', '')">월</div>
                  <div v-for="month in availableEndMonths" :key="'em-' + month"
                    :class="[$style.customSelectOption, { [$style.selected]: dateFilterEndMonth === month }]"
                    @click.stop="selectMonth('end', month)">{{ month }}월</div>
                </div>
              </div>
            </div>
          </div>
          <div :class="$style.dateFilterFooter">
            <button :class="$style.dateFilterReset" @click="resetDateFilter">초기화</button>
            <button :class="$style.dateFilterApply" @click="applyDateFilter">적용</button>
          </div>
        </div>
      </div>
      <div :class="$style.searchBox">
        <input v-model="searchQuery" type="text" placeholder="제목, 라인업, 장소 검색" :class="$style.searchInput" />
      </div>

      <div :class="$style.filterBox">
        <button @click="toggleSort" :class="$style.sortButton">
          {{ sortOrder === 'latest' ? '최신순' : sortOrder === 'popular' ? '인기순' : '이름순' }}
          <img :class="$style.sortIcon" src="@/assets/images/swap_vert.png" alt="정렬 변경" />
        </button>
      </div>

    </div>
  </div>

  <!-- 로딩 상태 - 스켈레톤 UI -->
  <div v-if="loading" :class="$style.skeletonContainer">
    <div :class="$style.skeletonTiles">
      <div v-for="i in 12" :key="i" :class="$style.skeletonItem">
        <div :class="$style.skeletonImage"></div>
        <div :class="$style.skeletonTitle"></div>
        <div :class="$style.skeletonDate"></div>
        <div :class="$style.skeletonLineup">
          <div :class="$style.skeletonPill"></div>
          <div :class="$style.skeletonPill"></div>
          <div :class="$style.skeletonPill"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- 달력 뷰 -->
  <div v-else-if="viewMode === 'calendar'" :class="$style.calendarContainer">
    <!-- 구글 캘린더 안내 배너 -->
    <router-link to="/my-calendar" :class="$style.calendarInfoBanner">
      <div :class="$style.calendarInfoGlow"></div>
      <div :class="$style.calendarInfoContent">
        <div :class="$style.calendarInfoIcon">📅</div>
        <div :class="$style.calendarInfoText">
          <span :class="$style.calendarInfoTitle">내 캘린더에서 구글 캘린더 연동하기</span>
          <span :class="$style.calendarInfoSub">찜한 공연 일정을 구글 캘린더로 바로 옮겨보세요</span>
        </div>
        <div :class="$style.calendarInfoBadge">🔗 바로가기</div>
      </div>
    </router-link>

    <!-- 달력 네비게이션 -->
    <div :class="$style.calendarHeader">
      <button :class="$style.navButton" @click="previousMonth">‹</button>
      <h2 :class="$style.monthTitle">{{ currentMonthText }}</h2>
      <button :class="$style.navButton" @click="nextMonth">›</button>
    </div>

    <!-- 달력 그리드 -->
    <div :class="$style.calendarWrapper">
      <!-- 요일 헤더 -->
      <div :class="$style.weekdayHeader">
        <div v-for="day in weekdays" :key="day" :class="$style.weekday">{{ day }}</div>
      </div>

      <!-- 날짜 셀 -->
      <div :class="$style.calendarGrid">
        <div v-for="(date, index) in calendarDays" :key="index" :class="[
          $style.calendarDay,
          { [$style.otherMonth]: !date.isCurrentMonth },
          { [$style.sunday]: date.dayOfWeek === 0 },
        ]" @click="selectCalendarDate(date)">
          <!-- 날짜 숫자 -->
          <div :class="[$style.dayNumberWrap, { [$style.todayBadge]: date.isToday }]">
            <span :class="$style.dayNumber">{{ date.day }}</span>
          </div>
          <!-- 원형 포스터 모음 -->
          <div v-if="date.events.length > 0" :class="$style.circlePosters">
            <div v-for="(ev, i) in date.events" :key="ev.id || i"
              :class="[$style.circlePoster, { [$style.circlePosterPlaceholder]: !ev.imgUrl }]"
              :style="ev.imgUrl ? { backgroundImage: `url(${ev.imgUrl})` } : {}" />
          </div>
          <!-- 이벤트 pill 목록 -->
          <div :class="$style.calendarDayEvents">
            <div v-for="(ev, i) in date.events" :key="(ev.id || 't') + i"
              :class="[$style.calendarEventPill, $style[`eventType__${ev.type || 'default'}`]]" :title="ev.title">
              {{ ev.title || '제목 없음' }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 선택된 날짜의 공연 목록 -->
    <div v-if="selectedDateEvents.length > 0" :class="$style.selectedDateEvents">
      <h3 :class="$style.selectedDateTitle">{{ selectedDateText }} 공연 ({{ selectedDateEvents.length }}개)</h3>
      <div :class="$style.eventsList">
        <div v-for="live in selectedDateEvents" :key="live.id" :class="$style.tileItem" style="cursor:pointer"
          @click="goToDetail(live)">
          <div :class="[
            $style.imgDiv,
            { [$style.ddayGlow]: calculateDaysLeft(live.date) === 'D-DAY' },
            { [$style.linkookGlow]: live.linkookReservation && live.isReservationOpened && !live.isReservationClosed },
          ]">
            <p :class="calculateDaysLeft(live.date) === '종료'
              ? $style.closed
              : calculateDaysLeft(live.date) === 'D-DAY'
                ? $style.ddayLabel
                : $style.dayCount
              ">{{ calculateDaysLeft(live.date) }}</p>
            <img :class="$style.liveType" loading="lazy" alt="" :src="typeUrl(live.type)" />
            <img v-if="!live.imageError && live.imgUrl" loading="lazy" :alt="live.title" :src="live.imgUrl"
              @error="handleImageError(live)" />
            <div v-else-if="!live.imageError" :class="$style.posterLoading">
              <span :class="$style.posterLoadingIcon" aria-hidden="true">♪</span>
            </div>
            <div v-else :class="$style.imagePlaceholder">
              <div :class="$style.placeholderIcon">🎵</div>
              <div :class="$style.placeholderText">{{ live.title }}</div>
            </div>
            <div v-if="calculateDaysLeft(live.date) === '종료'" :class="$style.endedOverlay"></div>
          </div>
          <div :class="$style.date">{{ live.date }}</div>
          <div :class="$style.title">{{ live.title }}</div>
          <div v-if="live.lineup && live.lineup.length >= 2" :class="$style.lineup">
            <div :class="[$style.lineupMarquee, { [$style.animate]: shouldAnimateLineup(live.lineup) }]">
              <span v-for="(member, idx) in live.lineup" :key="idx" :class="$style.lineupPill">{{ member }}</span>
              &nbsp;&nbsp;
              <span v-for="(member, idx) in live.lineup" :key="`dup-${idx}`" :class="$style.lineupPill">{{ member
              }}</span>
            </div>
          </div>
          <div v-else :class="$style.lineup">
            <div :class="[$style.lineupMarquee, { [$style.animate]: shouldAnimateLineup(live.lineup) }]">
              <span v-for="(member, idx) in live.lineup" :key="idx" :class="$style.lineupPill_one">{{ member }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 타일 뷰 (기존) -->
  <div v-else :class="$style.tiles">
    <div :class="[$style.tileItem, { [$style.dummyItem]: live.isDummy }]" v-for="(live, index) in paginatedItems"
      :key="live.isDummy ? live.id : index" @click="!live.isDummy && goToDetail(live)"
      :style="live.isDummy ? '' : 'cursor: pointer'">
      <div v-if="!live.isDummy" :class="[
        $style.imgDiv,
        { [$style.ddayGlow]: calculateDaysLeft(live.date) === 'D-DAY' },
        {
          [$style.linkookGlow]:
            live.linkookReservation && live.isReservationOpened && !live.isReservationClosed,
        },
      ]">
        <p v-if="live.linkookReservation && live.isReservationOpened && !live.isReservationClosed"
          :class="$style.linkookLabel">
          링꾹예매중
        </p>
        <!-- 임시저장 상태 표시 (작성자 및 관리자에게 보임) -->
        <p v-if="live.status === 'draft' && (userStore.auth === 'admin' || live.reg_id === userStore.email || live.createdBy === userStore.email)"
          :class="$style.draftLabel">
          임시저장
        </p>
        <!-- 승인되지 않은 공연 표시 (관리자 및 등록자에게 보임) -->
        <p v-else-if="!live.approved && (userStore.auth === 'admin' || live.reg_id === userStore.email || live.createdBy === userStore.email)"
          :class="$style.pendingLabel">
          승인 대기
        </p>
        <p v-else :class="calculateDaysLeft(live.date) === '종료'
          ? $style.closed
          : calculateDaysLeft(live.date) === 'D-DAY'
            ? $style.ddayLabel
            : $style.dayCount
          ">
          {{ calculateDaysLeft(live.date) }}
        </p>
        <button :class="[$style.likeBtnOverlay, { [$style.liked]: live.liked }]"
          @click.stop="handleLiveLikeClick(live)">
          <img v-if="live.liked" :class="$style.likeHeart" src="@/assets/images/heart.png" />
          <img v-else :class="$style.likeHeart" src="@/assets/images/no_heart.png" />
        </button>
        <!-- <p :class="$style.liveType">{{ live.type }}</p> -->
        <img :class="$style.liveType" loading="lazy" alt="" :src="typeUrl(live.type)" />
        <!-- 포스터 이미지 또는 플레이스홀더 -->
        <img v-if="!live.imageError && live.imgUrl" loading="lazy" :alt="live.title" :src="live.imgUrl"
          @error="handleImageError(live)" />
        <div v-else-if="!live.imageError" :class="$style.posterLoading">
          <span :class="$style.posterLoadingIcon" aria-hidden="true">♪</span>
        </div>
        <div v-else :class="$style.imagePlaceholder">
          <div :class="$style.placeholderIcon">🎵</div>
          <div :class="$style.placeholderText">{{ live.title }}</div>
        </div>
        <!-- 종료된 라이브 오버레이 -->
        <div v-if="calculateDaysLeft(live.date) === '종료'" :class="$style.endedOverlay"></div>
      </div>
      <template v-if="!live.isDummy">
        <div :class="$style.date">{{ live.date }}</div>
        <div :class="$style.title">{{ live.title }}</div>
        <!-- <div :class="$style.place">{{ live.place }}</div> -->
        <div v-if="live.lineup && live.lineup.length >= 2" :class="$style.lineup">
          <div :class="[
            $style.lineupMarquee,
            { [$style.animate]: shouldAnimateLineup(live.lineup) },
          ]">
            <span v-for="(member, idx) in live.lineup" :key="idx" :class="$style.lineupPill">
              {{ member }}
            </span>
            &nbsp;&nbsp;
            <span v-for="(member, idx) in live.lineup" :key="`duplicate-${idx}`" :class="$style.lineupPill">
              {{ member }}
            </span>
          </div>
        </div>
        <div v-else :class="$style.lineup">
          <div :class="[
            $style.lineupMarquee,
            { [$style.animate]: shouldAnimateLineup(live.lineup) },
          ]">
            <span v-for="(member, idx) in live.lineup" :key="idx" :class="$style.lineupPill_one">
              {{ member }}
            </span>
          </div>
        </div>
        <!-- <div v-if="userStore.auth === 'admin'" :class="$style.commentLikeRow">
          <div v-if="typeof live.commentCount === 'number'" :class="$style.commentCount">
            💬 {{ live.commentCount }}
          </div>
          <div :class="$style.likeSection">
            <div
              :class="[$style.likeBtn, { [$style.liked]: live.liked }]"
              style="font-size: 0.8125rem; line-height: 1"
            >
              <span v-if="live.liked" style="color: #ff4b4b">❤️</span>
              <span v-else style="color: #bbb">🩶</span>
            </div>
            <span style="color: #888">{{ live.likes || 0 }}</span>
          </div>
        </div> -->
        <div :class="$style.blank"></div>
      </template>
      <!-- <img
              loading="lazy"
              :src="imageUrl"
            /> -->
    </div>
  </div>

  <!-- 페이지네이션 (타일 뷰에서만 표시) -->
  <div v-if="viewMode === 'tiles' && totalPages > 1" :class="$style.pagination">
    <button :class="$style.pageButton" @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
      ‹
    </button>

    <button v-for="page in pageRange" :key="page" :class="[
      $style.pageButton,
      { [$style.activePage]: page === currentPage },
    ]" @click="goToPage(page)">
      {{ page }}
    </button>

    <button :class="$style.pageButton" @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">
      ›
    </button>
  </div>
  <!-- 모바일 floating 버튼 -->
  <button v-if="!userStore.loginPopup && !userStore.nicknamePopup && !userStore.isBlocked" @click="openPopup" :class="[
    $style.floatingButton,
    { [$style.adminFloating]: true },
  ]">
    <span>+ 신규등록</span>
  </button>

  <!-- 팝업 -->
  <linkook-live-form :is-visible="showPopup" mode="create" @close-popup="closePopup"
    @success="handleSuccess"></linkook-live-form>
</template>

<script>
import {
  collection,
  getDocs,
} from "firebase/firestore";
import { ref } from "firebase/storage";
import { getDownloadURL } from "@/utils/storageWithNavigation";
import { firestore, storage } from "/firebaseConfig";
import { parse, isValid, isPast, format, startOfMonth, endOfMonth, startOfWeek, endOfWeek, addMonths, subMonths, isSameDay } from "date-fns";
import { ko } from "date-fns/locale";
import { useUserStore } from "@/store/user";
import scrollManager from "@/utils/scrollManager";
import { toggleLiveLike as toggleLiveLikeApi } from "@/utils/write/user";
import { trackActivity, ACTIVITY_TYPES } from "@/utils/activityTracker";
import LinkookLiveForm from "@/components/modal/form/LiveForm.vue";

export default {
  name: "LinkookLiveTiles",
  components: {
    LinkookLiveForm,
  },
  computed: {
    // 오늘부터 7일 후까지의 라이브 정보 (전광판용)
    thisWeekLives() {
      const now = new Date();
      now.setHours(0, 0, 0, 0); // 오늘 자정

      const endDate = new Date(now);
      endDate.setDate(now.getDate() + 7); // 7일 후
      endDate.setHours(23, 59, 59, 999);

      return this.lives
        .filter((live) => {
          const liveDate = this.parseDate(live.date);
          return liveDate && liveDate >= now && liveDate <= endDate;
        })
        .sort((a, b) => {
          // 링꾹 예매 라이브를 우선적으로 표시 (예매가 시작되고 종료되지 않은 것만)
          const isLinkookA = a.linkookReservation === true && a.isReservationOpened && !a.isReservationClosed;
          const isLinkookB = b.linkookReservation === true && b.isReservationOpened && !b.isReservationClosed;

          if (isLinkookA && !isLinkookB) return -1;
          if (!isLinkookA && isLinkookB) return 1;

          // 링꾹 예매 여부가 같으면 날짜순 정렬
          const dateA = this.parseDate(a.date);
          const dateB = this.parseDate(b.date);
          return (dateA || 0) - (dateB || 0);
        })
        .slice(0, 8); // 최대 8개까지만 표시
    },

    filteredItems() {
      const query = this.searchQuery.toLowerCase();

      return this.lives
        .filter((item) => {
          // 검색어 조건 필터 (title, place, lineup, crews)
          const title = (item?.title || "").toLowerCase();
          const place = (item?.place || "").toLowerCase();
          const lineup = Array.isArray(item?.lineup) ? item.lineup : [];
          const crews = (item?.crews || "").toLowerCase();

          const matchesQueryInTitle = title.includes(query);
          const matchesQueryInPlace = place.includes(query);
          const matchesQueryInLineup = lineup.some((lineupItem) =>
            String(lineupItem || "").toLowerCase().includes(query)
          );
          const matchesQueryInCrews = crews.includes(query);
          const matchesQuery =
            matchesQueryInTitle ||
            matchesQueryInPlace ||
            matchesQueryInLineup ||
            matchesQueryInCrews;

          // 타입 조건 필터 (토글 방식)
          const { vocal, band, dance, other } = this.selectedTypes;
          const normalizedType = item.type || "default";
          let matchesType = true;

          // 하나 이상의 타입이 선택된 경우
          if (vocal || band || dance || other) {
            matchesType = false;
            if (vocal && normalizedType === "vocal") matchesType = true;
            if (band && normalizedType === "band") matchesType = true;
            if (dance && normalizedType === "dance") matchesType = true;
            if (other && !["vocal", "band", "dance"].includes(normalizedType)) matchesType = true;
          }

          // 좋아요 필터
          const matchesLiked = !this.likedOnly || item.liked;

          // 날짜 필터
          let matchesDate = true;
          if (this.dateFilterStart || this.dateFilterEnd) {
            const itemDate = this.parseDate(item.date);
            if (itemDate) {
              if (this.dateFilterStart && itemDate < this.dateFilterStart) {
                matchesDate = false;
              }
              if (this.dateFilterEnd && itemDate > this.dateFilterEnd) {
                matchesDate = false;
              }
            }
          }

          // 아무것도 선택 안 되면 전체
          return matchesQuery && matchesType && matchesLiked && matchesDate;
        })
        .sort((a, b) => {
          // 임시저장 여부 확인 (임시저장을 최우선으로 배치)
          const isDraftA = a.status === "draft";
          const isDraftB = b.status === "draft";

          if (isDraftA && !isDraftB) return -1; // A가 임시저장, B가 아님 -> A를 앞으로
          if (!isDraftA && isDraftB) return 1; // A가 아님, B가 임시저장 -> B를 앞으로

          // 승인 여부 확인 (승인되지 않은 공연을 최우선으로 배치)
          const isApprovedA = a.approved !== false; // undefined나 true는 승인된 것으로 간주
          const isApprovedB = b.approved !== false;

          if (!isApprovedA && isApprovedB) return -1; // A가 미승인, B가 승인됨 -> A를 앞으로
          if (isApprovedA && !isApprovedB) return 1; // A가 승인됨, B가 미승인 -> B를 앞으로

          // 인기순 정렬인 경우 - 종료 여부와 상관없이 인기순으로만 정렬
          if (this.sortOrder === "popular") {
            return (b.likes || 0) - (a.likes || 0);
          }

          // 이름순 정렬인 경우 - 종료 여부와 상관없이 이름순으로만 정렬
          if (this.sortOrder === "name") {
            const titleA = (a.title || "").toLowerCase();
            const titleB = (b.title || "").toLowerCase();
            return titleA.localeCompare(titleB, "ko");
          }

          // 아래는 최신순(latest) 정렬 로직

          // D-Day 여부 확인
          const isDdayA = this.calculateDaysLeft(a.date) === "D-DAY";
          const isDdayB = this.calculateDaysLeft(b.date) === "D-DAY";

          // D-Day 항목들을 최우선으로 배치
          if (isDdayA && !isDdayB) return -1;
          if (!isDdayA && isDdayB) return 1;

          // date-fns를 활용한 포맷팅 변환 (점(.)을 자동으로 처리)
          const parseDate = (dateStr) => {
            const tempDateStr = dateStr.replace(/\./g, "-").trim(); // 점(.)을 대시(-)로 변경
            const formattedDateStr = !tempDateStr.includes(":") // 시간이 없는 경우 기본값 " 00:00" 추가
              ? tempDateStr + " 00:00"
              : tempDateStr;

            return parse(formattedDateStr, "yyyy-MM-dd HH:mm", new Date());
          };

          const dateA = parseDate(a.date);
          const dateB = parseDate(b.date);

          // 날짜가 유효한지 확인 (Invalid Date 방지)
          if (!isValid(dateA) || !isValid(dateB)) {
            console.error("Invalid date detected:", a.date, b.date);
            return 0;
          }

          // 날짜 부분만 비교 (시간 제외)
          const getDateOnly = (date) => {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate());
          };
          const dateOnlyA = getDateOnly(dateA);
          const dateOnlyB = getDateOnly(dateB);
          const isSameDate = dateOnlyA.getTime() === dateOnlyB.getTime();

          // 같은 날짜인 경우에만 링꾹 예매 우선 배치
          if (isSameDate) {
            const isLinkookA =
              a.linkookReservation === true && a.isReservationOpened && !a.isReservationClosed;
            const isLinkookB =
              b.linkookReservation === true && b.isReservationOpened && !b.isReservationClosed;

            if (isLinkookA && !isLinkookB) return -1;
            if (!isLinkookA && isLinkookB) return 1;
          }

          // 과거 여부 판별 (D-Day는 제외하고 판별)
          const isPastA = isPast(dateA);
          const isPastB = isPast(dateB);

          // 과거와 미래 항목 분리 (미래는 앞으로, D-Day는 이미 앞쪽에 배치됨)
          if (isPastA && !isPastB) return 1;
          if (!isPastA && isPastB) return -1;

          // 최신순: 같은 상태의 항목끼리 날짜 정렬
          return isPastA ? dateB - dateA : dateA - dateB;
        });
    },
    userStore() {
      return useUserStore();
    },

    // 날짜 필터용 년도 목록 (라이브가 존재하는 년도만)
    availableYears() {
      const yearsSet = new Set();
      this.lives.forEach((live) => {
        const date = this.parseDate(live.date);
        if (date) {
          yearsSet.add(date.getFullYear());
        }
      });
      return Array.from(yearsSet).sort((a, b) => b - a); // 내림차순 정렬
    },
    // 시작 년도에서 라이브가 존재하는 월 목록
    availableStartMonths() {
      if (!this.dateFilterStartYear) return [];
      const monthsSet = new Set();
      this.lives.forEach((live) => {
        const date = this.parseDate(live.date);
        if (date && date.getFullYear() === this.dateFilterStartYear) {
          monthsSet.add(date.getMonth() + 1);
        }
      });
      return Array.from(monthsSet).sort((a, b) => a - b); // 오름차순 정렬
    },
    // 종료 년도 목록 (시작 년도 이상만)
    availableEndYears() {
      let years = this.availableYears;
      if (this.dateFilterStartYear) {
        years = years.filter(year => year >= this.dateFilterStartYear);
      }
      return years;
    },
    // 종료 년도에서 라이브가 존재하는 월 목록 (시작 월 이상만)
    availableEndMonths() {
      if (!this.dateFilterEndYear) return [];
      const monthsSet = new Set();
      this.lives.forEach((live) => {
        const date = this.parseDate(live.date);
        if (date && date.getFullYear() === this.dateFilterEndYear) {
          monthsSet.add(date.getMonth() + 1);
        }
      });
      let months = Array.from(monthsSet).sort((a, b) => a - b);
      // 같은 년도라면 시작 월 이상만 표시
      if (this.dateFilterStartYear && this.dateFilterEndYear === this.dateFilterStartYear && this.dateFilterStartMonth) {
        months = months.filter(month => month >= this.dateFilterStartMonth);
      }
      return months;
    },

    // 페이지네이션된 아이템
    paginatedItems() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      const items = this.filteredItems.slice(startIndex, endIndex);

      // 4개씩 줄을 맞추기 위해 가짜 아이템 추가
      const remainder = items.length % 4;
      if (remainder !== 0) {
        const dummyCount = 4 - remainder;
        for (let i = 0; i < dummyCount; i++) {
          items.push({ isDummy: true, id: `dummy-${i}` });
        }
      }

      return items;
    },
    // 총 페이지 수
    totalPages() {
      return Math.ceil(this.filteredItems.length / this.itemsPerPage);
    },
    // 페이지 범위 (최대 5개 페이지 버튼 표시)
    pageRange() {
      const total = this.totalPages;
      const current = this.currentPage;

      if (total <= 5) {
        const pages = [];
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
        return pages;
      }

      let start, end;

      if (current <= 3) {
        start = 1;
        end = 5;
      } else if (current >= total - 2) {
        start = total - 4;
        end = total;
      } else {
        start = current - 2;
        end = current + 2;
      }

      const pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },

    // 달력 뷰 관련 computed
    currentMonthText() {
      return format(this.calendarCurrentDate, "yyyy년 M월", { locale: ko });
    },
    weekdays() {
      return ["일", "월", "화", "수", "목", "금", "토"];
    },
    calendarDays() {
      const monthStart = startOfMonth(this.calendarCurrentDate);
      const monthEnd = endOfMonth(this.calendarCurrentDate);
      const calendarStart = startOfWeek(monthStart, { weekStartsOn: 0 });
      const calendarEnd = endOfWeek(monthEnd, { weekStartsOn: 0 });

      const days = [];
      let currentDay = new Date(calendarStart);

      while (currentDay <= calendarEnd) {
        const dayEvents = this.getEventsForDate(currentDay);
        const isCurrentMonth = currentDay.getMonth() === this.calendarCurrentDate.getMonth();
        const isToday = isSameDay(currentDay, new Date());

        days.push({
          date: new Date(currentDay),
          day: currentDay.getDate(),
          dayOfWeek: currentDay.getDay(), // 0=일, 6=토
          isCurrentMonth,
          isToday,
          hasEvent: dayEvents.length > 0,
          events: dayEvents,
        });

        currentDay.setDate(currentDay.getDate() + 1);
      }

      return days;
    },
    calendarWeeks() {
      const days = this.calendarDays;
      const weeks = [];
      for (let i = 0; i < days.length; i += 7) {
        weeks.push(days.slice(i, i + 7));
      }
      return weeks;
    },
    selectedDateEvents() {
      if (!this.selectedCalendarDate) return [];
      return this.getEventsForDate(this.selectedCalendarDate);
    },
    selectedDateText() {
      if (!this.selectedCalendarDate) return "";
      return format(this.selectedCalendarDate, "M월 d일", { locale: ko });
    },
  },
  created() {
    this.fetchLives();
    // this.fetchImg();
  },
  mounted() {
    // this.recordVisitor();
  },
  data() {
    return {
      searchQuery: "",
      lives: [],
      imageUrl: "",
      showPopup: false, // 팝업 상태
      loading: true, // 로딩 상태 추가

      selectedTypes: { vocal: false, band: false, dance: false, other: false },
      likedOnly: false, // 추가: 좋아요 필터 상태
      sortOrder: "latest", // 정렬 순서: 'latest' (최신순), 'popular' (인기순), 'name' (이름순)
      // 페이지네이션 관련
      currentPage: 1,
      itemsPerPage: 12, // 한 페이지당 표시할 아이템 수
      // 날짜 필터 관련
      showDateFilter: false,
      dateFilterStartYear: "",
      dateFilterStartMonth: "",
      dateFilterEndYear: "",
      dateFilterEndMonth: "",
      dateFilterStart: null, // 적용된 시작 날짜
      dateFilterEnd: null, // 적용된 종료 날짜
      openDropdown: null, // 현재 열린 드롭다운 ('startYear', 'startMonth', 'endYear', 'endMonth')
      // 달력 뷰 관련
      viewMode: "tiles", // 'tiles' 또는 'calendar'
      calendarCurrentDate: new Date(),
      selectedCalendarDate: null,
    };
  },
  watch: {
    // 검색어나 필터 변경 시 첫 페이지로
    searchQuery() {
      this.currentPage = 1;
    },
    selectedTypes: {
      handler() {
        this.currentPage = 1;
      },
      deep: true,
    },
    likedOnly() {
      this.currentPage = 1;
    },
    sortOrder() {
      this.currentPage = 1;
    },
    dateFilterStart() {
      this.currentPage = 1;
    },
    dateFilterEnd() {
      this.currentPage = 1;
    },
    // 페이지 변경 시 포스터 이미지 로드
    currentPage() {
      this.$nextTick(() => {
        this.loadPosterImagesForCurrentPage();
      });
    },
    // filteredItems가 변경될 때마다 이미지 로드 (검색/필터 포함). 초기 로딩 중에는 fetchLives에서 처리
    filteredItems() {
      if (this.loading) return;
      this.$nextTick(async () => {
        if (this.viewMode === "tiles") {
          this.loadPosterImagesForCurrentPage();
        } else if (this.viewMode === "calendar") {
          await this.loadCalendarImages();
        }
      });
    },
    // 로그인 상태 변경 감지 (로그아웃 시 라이브 목록 재로드)
    "userStore.isLogin"(newVal, oldVal) {
      // 로그인 상태가 변경되었을 때 라이브 목록 재로드
      if (oldVal !== newVal) {
        this.fetchLives();
      }
    },
    // 달력 현재 날짜 변경 감지 (월 변경)
    calendarCurrentDate() {
      if (this.viewMode === "calendar") {
        this.$nextTick(async () => {
          await this.loadCalendarImages();
        });
      }
    },
    // 뷰 모드 변경 감지
    viewMode(newMode) {
      if (newMode === "calendar") {
        this.$nextTick(async () => {
          await this.loadCalendarImages();
        });
      }
    },
  },
  methods: {
    changeType(typeNum) {
      this.type = typeNum;
    },
    toggleType(type) {
      this.selectedTypes[type] = !this.selectedTypes[type];
    },
    resetTypes() {
      this.selectedTypes = { vocal: false, band: false, dance: false, other: false };
    },
    // iOS 호환 날짜 파싱 헬퍼 함수
    parseDate(dateStr) {
      if (!dateStr) return null;
      try {
        // "yyyy.MM.dd HH:mm" 또는 "yyyy.MM.dd" 형식 처리
        const parts = dateStr.split(' ');
        const datePart = parts[0];
        const timePart = parts[1] || '00:00';

        const [year, month, day] = datePart.split('.').map(Number);
        const [hour, minute] = timePart.split(':').map(Number);

        return new Date(year, month - 1, day, hour || 0, minute || 0);
      } catch {
        return null;
      }
    },
    toggleSort() {
      if (this.sortOrder === "latest") {
        this.sortOrder = "popular";
      } else if (this.sortOrder === "popular") {
        this.sortOrder = "name";
      } else {
        this.sortOrder = "latest";
      }
    },
    // 동기화 버튼 핸들러 (뷰 모드 전환)
    handleSync() {
      this.viewMode = this.viewMode === "tiles" ? "calendar" : "tiles";
      this.selectedCalendarDate = null;
      // watch에서 viewMode 변경 감지하여 이미지 로드
    },
    // 달력 네비게이션
    previousMonth() {
      this.calendarCurrentDate = subMonths(this.calendarCurrentDate, 1);
      this.selectedCalendarDate = null;
      // watch에서 calendarCurrentDate 변경 감지하여 이미지 로드
    },
    nextMonth() {
      this.calendarCurrentDate = addMonths(this.calendarCurrentDate, 1);
      this.selectedCalendarDate = null;
      // watch에서 calendarCurrentDate 변경 감지하여 이미지 로드
    },
    selectCalendarDate(dateObj) {
      if (dateObj.hasEvent) {
        this.selectedCalendarDate = dateObj.date;
      } else {
        this.selectedCalendarDate = null;
      }
    },
    getEventsForDate(date) {
      return this.filteredItems.filter((live) => {
        if (!live.date) return false;
        try {
          const liveDate = this.parseDate(live.date);
          if (!liveDate || !isValid(liveDate)) return false;
          return isSameDay(liveDate, date);
        } catch (error) {
          console.error("날짜 파싱 오류:", error, live.date);
          return false;
        }
      });
    },
    // 날짜 필터 관련 메서드
    toggleDateFilter() {
      this.showDateFilter = !this.showDateFilter;
      this.openDropdown = null;
    },
    toggleDropdown(dropdown) {
      this.openDropdown = this.openDropdown === dropdown ? null : dropdown;
    },
    selectYear(type, year) {
      if (type === 'start') {
        this.dateFilterStartYear = year;
        if (!year) this.dateFilterStartMonth = "";
      } else {
        this.dateFilterEndYear = year;
        if (!year) this.dateFilterEndMonth = "";
      }
      this.openDropdown = null;
    },
    selectMonth(type, month) {
      if (type === 'start') {
        this.dateFilterStartMonth = month;
      } else {
        this.dateFilterEndMonth = month;
      }
      this.openDropdown = null;
    },
    resetDateFilter() {
      this.dateFilterStartYear = "";
      this.dateFilterStartMonth = "";
      this.dateFilterEndYear = "";
      this.dateFilterEndMonth = "";
      this.dateFilterStart = null;
      this.dateFilterEnd = null;
      this.openDropdown = null;
      this.currentPage = 1;
      this.showDateFilter = false; // 모달 닫기
    },
    applyDateFilter() {
      // 시작 날짜 설정
      if (this.dateFilterStartYear && this.dateFilterStartMonth) {
        this.dateFilterStart = new Date(this.dateFilterStartYear, this.dateFilterStartMonth - 1, 1);
      } else if (this.dateFilterStartYear) {
        this.dateFilterStart = new Date(this.dateFilterStartYear, 0, 1);
      } else {
        this.dateFilterStart = null;
      }

      // 종료 날짜 설정 (해당 월의 마지막 날)
      if (this.dateFilterEndYear && this.dateFilterEndMonth) {
        this.dateFilterEnd = new Date(this.dateFilterEndYear, this.dateFilterEndMonth, 0, 23, 59, 59);
      } else if (this.dateFilterEndYear) {
        this.dateFilterEnd = new Date(this.dateFilterEndYear, 11, 31, 23, 59, 59);
      } else {
        this.dateFilterEnd = null;
      }

      // 날짜 필터 활동 기록
      if (this.dateFilterStart || this.dateFilterEnd) {
        trackActivity(ACTIVITY_TYPES.DATE_FILTER, {
          target: "live",
          metadata: {
            startYear: this.dateFilterStartYear || null,
            startMonth: this.dateFilterStartMonth || null,
            endYear: this.dateFilterEndYear || null,
            endMonth: this.dateFilterEndMonth || null,
          },
        });
      }

      this.showDateFilter = false;
      this.currentPage = 1;
    },
    calculateDaysLeft(targetDate) {
      const substrDate = targetDate.substring(0, 10);
      if (!substrDate) return "Invalid date";
      const now = new Date();
      const eventDate = parse(substrDate, "yyyy.MM.dd", new Date()); // 파싱
      if (isNaN(eventDate.getTime())) return "Invalid date";

      const nowMidnight = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      );
      const eventMidnight = new Date(
        eventDate.getFullYear(),
        eventDate.getMonth(),
        eventDate.getDate()
      );
      // console.log("nowMidnight ", nowMidnight);
      // console.log("eventMidnight ", eventMidnight);

      const daysLeft = Math.ceil(
        (eventMidnight - nowMidnight) / (1000 * 60 * 60 * 24)
      );
      // console.log("daysLeft ", daysLeft);
      // 공연 당일까지는 D-Day로 표시 (daysLeft가 0 이상이면)
      return daysLeft === 0 ? "D-DAY" : daysLeft > 0 ? `D-${daysLeft}` : `종료`;
    },
    async fetchLives() {
      try {
        this.loading = true; // 로딩 시작
        // 좋아요 목록과 lives 컬렉션을 병렬로 요청해 초기 로딩 시간 단축
        const [likesResult, querySnapshot] = await Promise.all([
          this.userStore.isLogin
            ? import("@/utils/read/user").then(({ getUserLikes }) =>
              getUserLikes(this.userStore.email).then((likes) => likes.liveLikes || []).catch((e) => {
                console.warn("사용자 좋아요 정보 조회 실패:", e);
                return [];
              })
            )
            : Promise.resolve([]),
          getDocs(collection(firestore, "lives")),
        ]);
        const userLiveLikes = likesResult;

        // 댓글 개수는 목록에서 사용하지 않으므로 서브컬렉션 조회 제거 (N+1 방지)
        const livesWithComments = querySnapshot.docs.map((docSnap) => {
          const data = docSnap.data();

          // 관리자가 아닌 경우 approved가 true인 것만 표시
          // 관리자 또는 등록자인 경우 approved가 false인 것도 포함
          const isCreator = this.userStore.isLogin &&
            (data.reg_id === this.userStore.email || data.createdBy === this.userStore.email);
          const shouldShow = data.approved || this.userStore.auth === "admin" || isCreator;

          // 임시저장 상태는 작성자만 볼 수 있음
          const isDraft = data.status === "draft";
          if (isDraft && !isCreator && this.userStore.auth !== "admin") {
            return null;
          }

          if (shouldShow) {
            // 포스터 이미지는 페이지별로 나중에 로드 (원본 img 필드만 저장)
            // 좋아요 수 및 liked 여부
            const likes = data.likes || 0;
            const liked = userLiveLikes.includes(docSnap.id);

            // 링꾹 예매인 경우 예매 시작/종료 시간 가져오기
            let reservationStartDate = null;
            let reservationEndDate = null;
            let isReservationOpened = false;
            let isReservationClosed = false;
            if (data.linkookReservation) {
              const now = new Date();
              const parseReservationStr = (s) => {
                if (typeof s !== "string") return null;
                const m = /^(\d{4})\.(\d{2})\.(\d{2}) (\d{2}):(\d{2})$/.exec(s.trim());
                if (!m) return null;
                return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), Number(m[4]), Number(m[5]));
              };

              reservationStartDate = parseReservationStr(data.reservationStartDate);
              reservationEndDate = parseReservationStr(data.reservationEndDate);
              isReservationOpened = reservationStartDate ? now >= reservationStartDate : false;
              isReservationClosed = reservationEndDate ? now > reservationEndDate : false;
            }

            return {
              ...data,
              img: data.img, // 원본 이미지 필드 (URL은 나중에 로드)
              imgUrl: null, // 로드된 이미지 URL (나중에 설정됨)
              imageError: false, // 이미지 로딩 에러 상태
              id: docSnap.id,
              commentCount: 0, // 목록에서는 미사용, 상세에서만 로드
              likes,
              liked,
              reservationStartDate,
              reservationEndDate,
              isReservationOpened,
              isReservationClosed,
            };
          }
          return null;
        });
        this.lives = livesWithComments.filter(Boolean);
        this.loading = false; // 데이터만 있으면 바로 리스트 표시 (스켈레톤 해제)
        // 포스터 URL은 백그라운드에서 로드해 이미지가 순차적으로 채워지도록 함
        this.loadPosterImagesForCurrentPage();
      } catch (error) {
        console.error("Error fetching lives:", error);
      } finally {
        this.loading = false; // 에러 시에도 로딩 해제
      }
    },
    // 현재 페이지에 표시되는 포스터 이미지만 로드
    async loadPosterImagesForCurrentPage() {
      const itemsToLoad = this.paginatedItems.filter(item => !item.isDummy);

      await Promise.all(
        itemsToLoad.map(async (item) => {
          // 이미 로드된 경우 스킵
          if (item.imgUrl) return;

          // 원본 이미지 필드 확인
          const imgField = item.img;
          if (!imgField) {
            item.imageError = true;
            return;
          }

          // 이미 http URL인 경우 그대로 사용
          if (imgField.startsWith("http")) {
            item.imgUrl = imgField;
            item.imageError = false;
            return;
          }

          // Firebase Storage에서 이미지 URL 가져오기
          try {
            const imageRef = ref(storage, `poster/${imgField}`);
            const imgUrl = await getDownloadURL(imageRef);
            item.imgUrl = imgUrl;
            item.imageError = false;
          } catch (e) {
            // 이미지 로드 실패 시 에러 상태로 설정
            console.warn(`이미지 로드 실패: ${imgField}`, e);
            item.imageError = true;
            item.imgUrl = null;
          }
        })
      );
    },
    // 달력 뷰에서 표시되는 모든 이미지 로드
    async loadCalendarImages() {
      // 달력에 표시되는 모든 날짜의 이벤트 ID 수집
      const eventIds = new Set();
      this.calendarDays.forEach(day => {
        if (day.events && day.events.length > 0) {
          day.events.forEach(event => eventIds.add(event.id));
        }
      });

      // 원본 lives 배열에서 해당 이벤트들을 찾아서 이미지 로드
      const itemsToLoad = this.lives.filter(live => eventIds.has(live.id));

      await Promise.all(
        itemsToLoad.map(async (item) => {
          // 이미 로드된 경우 스킵
          if (item.imgUrl) return;

          // 원본 이미지 필드 확인
          const imgField = item.img;
          if (!imgField) {
            item.imageError = true;
            return;
          }

          // 이미 http URL인 경우 그대로 사용
          if (imgField.startsWith("http")) {
            item.imgUrl = imgField;
            item.imageError = false;
            return;
          }

          // Firebase Storage에서 이미지 URL 가져오기
          try {
            const imageRef = ref(storage, `poster/${imgField}`);
            const imgUrl = await getDownloadURL(imageRef);
            item.imgUrl = imgUrl;
            item.imageError = false;
          } catch (e) {
            // 이미지 로드 실패 시 에러 상태로 설정
            console.warn(`이미지 로드 실패: ${imgField}`, e);
            item.imageError = true;
            item.imgUrl = null;
          }
        })
      );
    },
    // async fetchImg() {
    //   // 이미지 URL 가져오기
    //   const imageRef = ref(storage, "oneoklive_banner.png");
    //   getDownloadURL(imageRef)
    //     .then((url) => {
    //       this.imageUrl = url;
    //       this.loading = false;
    //     })
    //     .catch((err) => {
    //       this.error = "이미지를 불러오는 데 실패했습니다.";
    //       this.loading = false;
    //       console.error(err);
    //     });
    // },
    openPopup() {
      if (!this.userStore.isLogin) {
        this.userStore.showLoginPopup('liveRegister');
        return;
      }
      this.showPopup = true;
      scrollManager.lock("liveTilesPopup");
    },
    closePopup() {
      this.showPopup = false;
      scrollManager.unlock("liveTilesPopup");
    },
    async handleSuccess() {
      // 등록/수정 성공 시 리스트 새로고침
      await this.fetchLives();
    },

    typeUrl(type) {
      return require(`@/assets/images/${type}.png`);
    },
    goToDetail(live) {
      this.$router.push({
        name: "LiveDetail",
        params: { slug: live.slug || live.id },
      });
    },

    // 찜 필터 버튼 클릭 핸들러
    handleLikeFilterClick() {
      if (!this.userStore.isLogin) {
        this.userStore.showLoginPopup('likeFilter');
        return;
      }
      this.likedOnly = !this.likedOnly;
    },
    // 공연 찜 버튼 클릭 핸들러
    handleLiveLikeClick(live) {
      if (!this.userStore.isLogin) {
        this.userStore.showLoginPopup('liveLike');
        return;
      }
      this.toggleLike(live);
    },
    async toggleLike(live) {
      // 현재 좋아요 상태 저장
      const currentLikedState = live.liked || false;
      this.updateLiveLike(live.id);
      try {
        await toggleLiveLikeApi(live.id, this.userStore.email, currentLikedState);
        // 좋아요만 업데이트 (전체 데이터 재로드 없음)
      } catch (e) {
        this.updateLiveLike(live.id);
        console.error("좋아요 처리 오류:", e);
        this.$alert("좋아요 처리 중 오류가 발생했습니다.");
      }
    },
    // 좋아요만 업데이트하는 메서드
    updateLiveLike(liveId) {
      const live = this.lives.find((l) => l.id === liveId);
      if (live) {
        // 현재 좋아요 상태를 반전
        live.liked = !live.liked;

        // 좋아요 수 업데이트
        if (live.liked) {
          live.likes = (live.likes || 0) + 1;
        } else {
          live.likes = Math.max(0, (live.likes || 0) - 1);
        }
      }
    },
    goToPage(page) {
      this.currentPage = page;
    },

    // 라인업 정보를 포맷팅하는 메서드
    formatLineup(lineup) {
      if (!lineup) return "";
      if (Array.isArray(lineup)) {
        return lineup.join(", ");
      }
      return lineup;
    },

    // 라인업 애니메이션 여부를 판단하는 메서드
    shouldAnimateLineup(lineup) {
      if (!Array.isArray(lineup) || lineup.length === 0) return false;
      if (lineup.length >= 2) return true;
      return this.getLineupTextLength(lineup) > 20;
    },

    // 라인업 텍스트 총 길이를 계산하는 메서드
    getLineupTextLength(lineup) {
      if (!lineup || !Array.isArray(lineup)) return 0;
      return lineup.join("").length;
    },

    // 라이브 상세 페이지로 이동
    goToLiveDetail(liveId) {
      if (!liveId) return;
      this.$router.push({
        name: "LiveDetail",
        params: { slug: liveId },
      });
    },

    // 이미지 로딩 에러 처리
    handleImageError(live) {
      live.imageError = true;
      live.imgUrl = null; // 404 에러 방지
    },
  },
};
</script>
<style module>
/* 전광판 애니메이션 */
.marqueeContainer {
  width: calc(90% - 20px);
  height: 30px;
  background: linear-gradient(45deg, #1a1a1a, #2d2d2d, #1a1a1a);
  overflow: hidden;
  position: relative;
  margin-bottom: 8px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  margin: auto;
  padding: 10px;
}

.marqueeContainer::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.1) 50%,
      transparent 100%);
  animation: shimmer 2s infinite;
  z-index: 1;
}

.marqueeContent {
  display: flex;
  align-items: center;
  height: 100%;
  animation: marquee 60s linear infinite;
  white-space: nowrap;
}

.marqueeItem {
  color: #7ef9ff;
  font-family: "Courier New", monospace;
  font-weight: bold;
  font-size: 0.75rem;
  margin-right: 300px;
  text-shadow: 0 0 10px #34ff93, 0 0 20px #7ef9ff;
  animation: glow 1.5s ease-in-out infinite alternate;
  transition: all 0.3s ease;
}

.marqueeItem:hover {
  color: #ffffff;
  text-shadow: 0 0 15px #34ff93, 0 0 30px #7ef9ff, 0 0 40px #00ffff;
  transform: scale(1.05);
}

@keyframes marquee {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

@keyframes glow {
  from {
    text-shadow: 0 0 10px #62f7ff, 0 0 20px #62f7ff, 0 0 30px #62f7ff;
  }

  to {
    text-shadow: 0 0 20px #2bf4ff, 0 0 30px #2bf4ff, 0 0 40px #2bf4ff;
  }
}

/* 금주의 라이브 섹션 */
.weeklySection {
  width: 90%;
  margin: 12px auto 0 auto;
  padding: 10px 0;
}

.weeklySectionHeader {
  margin-bottom: 10px;
  padding: 0 10px;
}

.weeklySectionTitle {
  font-family: "NanumSquareRoundEB", "NanumSquareRoundB", sans-serif;
  font-size: 1rem;
  color: #333;
}

.weeklyCardsWrapper {
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.weeklyCardsWrapper::-webkit-scrollbar {
  display: none;
}

.weeklyCards {
  display: flex;
  gap: 20px;
  padding: 0 10px 10px 10px;
}

.weeklyCard {
  flex-shrink: 0;
  width: calc((100% - 60px) / 4);
  min-width: 140px;
  max-width: 200px;
  cursor: pointer;
}

.weeklyImgDiv {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 2896 / 4096;
  overflow: hidden;
  border-radius: 10px;
  margin-bottom: 5px;
}

.weeklyImgDiv img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 10px;
}

.weeklyImagePlaceholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);
  border-radius: 10px;
}

.weeklyImagePlaceholder .placeholderIcon {
  font-size: 2.5rem;
  opacity: 0.5;
  margin-bottom: 0;
}

.weeklyDate {
  font-family: "NanumSquareRoundEB", "NanumSquareRoundB", sans-serif;
  font-weight: bold;
  text-align: left;
  font-size: 0.8rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  color: #777;
  padding-top: 4px;
}

.weeklyTitle {
  font-family: "NanumSquareRoundEB", "NanumSquareRoundB", sans-serif;
  font-weight: bold;
  text-align: left;
  font-size: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  color: #000;
  padding-top: 2px;
}

/* 필터 및 검색 컨트롤 */
.controls {
  width: 90%;
  margin: 12px auto 10px auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 10px;
  gap: 10px;
}

.typeFilter {
  display: flex;
  gap: 8px;
  align-items: center;
  overflow-x: auto;
  white-space: nowrap;
  flex-shrink: 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
  width: 100%;
  justify-content: flex-start;
}

.typeFilter::-webkit-scrollbar {
  display: none;
}

.likeButton {
  padding: 5px 7px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.likeButton:hover {
  background: #f8f9fa;
  border-color: #ff6b9d;
}

.likeButton:active {
  background: #ff6b9d;
  border-color: #ff6b9d;
}

.activeLike {
  background: #ff6b9d;
  color: white;
  border-color: #ff6b9d;
}

.activeLike:hover {
  background: #ff6b9d;
  border-color: #ff6b9d;
}

.likeIcon {
  width: 20px;
  height: 20px;
  margin-top: 3px;
}

.typeButton {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundB", sans-serif;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.activeType {
  background: #222;
  color: white;
  border-color: #222;
}

.registerButton {
  padding: 8px 16px;
  background: #66bdff;
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundB", sans-serif;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.registerButton:hover {
  background: #4a9eff;
}

.plusIcon {
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
}

.sortFilter {
  flex: 1;
  display: flex;
  gap: 8px;
  min-width: 200px;
  width: 100%;
}

.searchBox {
  flex: 1;
  min-width: 100px;
}

.searchInput {
  width: 100%;
  height: 34px !important;
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundR", sans-serif;
  transition: border-color 0.2s ease;
}

.searchInput:focus {
  outline: none;
  border-color: #66bdff;
}

.filterBox {
  flex-shrink: 0;
}

/* 동기화 버튼 스타일 */
.syncButtonWrapper {
  position: relative;
  flex-shrink: 0;
}

.syncButton {
  width: 36px;
  height: 35px;
  padding: 6px;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}


.syncButton:active {
  border-color: #66bdff;
}

.syncIcon {
  width: 20px;
  height: 20px;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.syncButton:hover .syncIcon {
  opacity: 0.8;
}

.syncButtonActive {
  background: #66bdff;
  border-color: #66bdff;
}

.syncButtonActive .syncIcon {
  opacity: 1;
  filter: brightness(0) invert(1);
}

/* 날짜 필터 스타일 */
.dateFilterWrapper {
  position: relative;
  flex-shrink: 0;
}

.dateFilterButton {
  width: 36px;
  height: 35px;
  padding: 6px;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.dateFilterButton:active {
  border-color: #66bdff;
}


.dateFilterActive {
  background: #66bdff;
  border-color: #66bdff;
}

.calendarIcon {
  width: 20px;
  height: 20px;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.dateFilterButton:hover .calendarIcon {
  opacity: 0.8;
}

.dateFilterActive .calendarIcon {
  opacity: 1;
  filter: brightness(0) invert(1);
}

.dateFilterDropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 280px;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 100;
  overflow: visible;
}

.dateFilterHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: linear-gradient(135deg, #66bdff 0%, #ff6b9d 100%);
  color: white;
}

.dateFilterTitle {
  font-family: "NanumSquareRoundB", sans-serif;
  font-size: 0.9375rem;
}

.dateFilterClose {
  background: none;
  border: none;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.dateFilterClose:hover {
  opacity: 1;
}

.dateFilterBody {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.dateFilterRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dateFilterLabel {
  font-family: "NanumSquareRoundB", sans-serif;
  font-size: 0.8125rem;
  color: #666;
  width: 36px;
  flex-shrink: 0;
}

/* 커스텀 드롭다운 */
.customSelect {
  flex: 1;
  position: relative;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.8125rem;
  font-family: "NanumSquareRoundR", sans-serif;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: border-color 0.2s ease;
  user-select: none;
}

.customSelect:hover {
  border-color: #66bdff;
}

.customSelect.disabled {
  background: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.6;
}

.customSelectText {
  color: #333;
}

.customSelect.disabled .customSelectText {
  color: #999;
}

.customSelectArrow {
  font-size: 0.625rem;
  color: #999;
  margin-left: 4px;
}

.customSelectOptions {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-height: 180px;
  overflow-y: auto;
  z-index: 10;
}

.customSelectOption {
  padding: 8px 10px;
  font-size: 0.8125rem;
  cursor: pointer;
  transition: background 0.15s ease;
}

.customSelectOption:hover {
  background: #f0f7ff;
}

.customSelectOption.selected {
  background: #66bdff;
  color: white;
}

.customSelectOption.selected:hover {
  background: #4a9eff;
}

.dateFilterFooter {
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #e9ecef;
  background: #f8f9fa;
}

.dateFilterReset {
  flex: 1;
  padding: 10px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 8px;
  font-family: "NanumSquareRoundR", sans-serif;
  font-size: 0.8125rem;
  color: #666;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dateFilterReset:hover {
  border-color: #999;
  background: #f5f5f5;
}

.dateFilterApply {
  flex: 1;
  padding: 10px;
  border: none;
  background: #66bdff;
  border-radius: 8px;
  font-family: "NanumSquareRoundB", sans-serif;
  font-size: 0.8125rem;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dateFilterApply:hover {
  background: #4a9eff;
}

.sortButton {
  padding: 8px 12px;
  background: #222;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-family: "NanumSquareRoundB", sans-serif;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.sortButton:hover {
  background: #333;
}

.sortIcon {
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
}

.desktopOnly {
  display: none;
}

.typeText.selected {
  color: white;
}

.tiles {
  padding: 10px;
  width: 90%;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.tileItem {
  box-sizing: border-box;
  min-width: 0;
  /* Grid 셀이 컨텐츠보다 작아질 수 있게 함 */
}

.dummyItem {
  display: none;
}

.tileItem img {
  width: 100%;
  height: 100%;
  z-index: 10;
  object-fit: cover;
  display: block;
  border-radius: 10px;
}

.title {
  font-family: "Paperlogy7", "NanumSquareRoundEB", "NanumSquareRoundB", sans-serif;
  font-weight: bold;
  text-align: left;
  font-size: 1.1rem;
  font-weight: 100;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  color: #333;
  padding: 4px 0px;
}

.date {
  font-family: "Paperlogy4", "NanumSquareRoundEB", "NanumSquareRoundB", sans-serif;
  font-weight: bold;
  text-align: left;
  font-size: 0.85rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  color: #777;
  padding: 2px 0px;
}

.place {
  font-family: "NanumSquareRoundEB", "NanumSquareRoundB", sans-serif;
  font-weight: bold;
  text-align: left;
  font-size: 0.75rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  color: #777;
  padding-bottom: 2px;
}

.lineup {
  margin-bottom: 2px;
  height: 20px;
  width: 100%;
  overflow: hidden;
  position: relative;
  padding-top: 4px;
}

.lineupMarquee {
  height: 15px;
  display: flex;
  gap: 4px;
  white-space: nowrap;
}

.lineupMarquee.animate {
  animation: lineupMarquee 15s linear infinite;
  transform: translateX(0%);
}

.lineupPill {
  background: #f2f2f2;
  color: #333;
  border-radius: 12px;
  padding: 1px 5px;
  font-size: 0.65rem;
  font-weight: 500;
  border: 1px solid #e0e0e0;
  display: inline-block;
  font-family: "NanumSquareRoundR", sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* max-width: 80px; */
  line-height: 13px;
  flex-shrink: 0;
}

.lineupPill_one {
  background: #f2f2f2;
  color: #333;
  border-radius: 12px;
  padding: 1px 5px;
  font-size: 0.75rem;
  font-weight: 500;
  border: 1px solid #e0e0e0;
  display: inline-block;
  font-family: "NanumSquareRoundR", sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* max-width: 80px; */
  line-height: 13px;
  flex-shrink: 0;
  width: 100%;
  text-align: center;
}

@keyframes lineupMarquee {
  0% {
    transform: translateX(0%);
  }

  50% {
    transform: translateX(-50%);
  }

  100% {
    transform: translateX(-100%);
  }
}

.imgDiv {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 2896 / 4096;
  /* 포스터 권장 비율 (약 1:1.414) */
  overflow: hidden;
  border-radius: 10px;
  margin-bottom: 5px;
}

/* 포스터 로딩 중 대기 UI (시머) */
.posterLoading {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg,
      #ebeef2 0%,
      #e2e6eb 18%,
      #edf0f4 40%,
      #e2e6eb 60%,
      #edf0f4 82%,
      #ebeef2 100%);
  background-size: 200% 100%;
  border-radius: 10px;
  animation: posterShimmer 1.8s ease-in-out infinite;
}

.posterLoadingIcon {
  font-size: 2.5rem;
  color: rgba(0, 0, 0, 0.08);
  font-weight: bold;
  line-height: 1;
}

@keyframes posterShimmer {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

.imagePlaceholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}

.placeholderIcon {
  font-size: 3rem;
  margin-bottom: 12px;
  opacity: 0.5;
}

.placeholderText {
  font-size: 0.875rem;
  color: #666;
  text-align: center;
  font-family: "NanumSquareRoundR", sans-serif;
  word-break: keep-all;
  line-height: 1.4;
  padding: 0 10px;
}

.dayCount {
  position: absolute;
  top: -5px;
  /* 이미지 위에서의 위치 */
  right: 5px;
  /* 이미지 왼쪽에서의 위치 */
  color: black;
  /* 글자 색 */
  font-size: 0.9rem;
  /* 글자 크기 */
  font-weight: bold;
  /* 글자 두께 */
  font-family: var(--font-noto-b);
  background-color: rgba(255, 255, 255, 1);
  /* 반투명 배경 */
  padding: 0px 5px;
  /* 배경과 글씨 사이의 여백 */
  border-radius: 5px;
  /* 배경의 모서리를 둥글게 */
  line-height: 18px;
}

.likeBtnOverlay {
  position: absolute;
  bottom: 5px;
  /* 이미지 위에서의 위치 */
  right: 5px;
  /* 이미지 왼쪽에서의 위치 */
  color: black;
  /* 글자 색 */
  z-index: 10;
  border-radius: 5px;
  /* 배경의 모서리를 둥글게 */
  padding-bottom: 2px;
}

.likeHeart {
  padding: 5px;
  /* 배경과 글씨 사이의 여백 */
  margin: 0px 2px;
  border-radius: 20px !important;
  /* 배경의 모서리를 둥글게 */
  width: 30px !important;
  height: 30px !important;
  border: 1px solid #ccc;
  object-fit: fill !important;
  background-color: rgba(0, 0, 0, 0.3);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}

.likeBtnOverlay.liked .likeHeart {
  background-color: white;
}

.liveType {
  position: absolute;
  bottom: 5px;
  /* 이미지 위에서의 위치 */
  left: 5px;
  /* 이미지 왼쪽에서의 위치 */
  color: black;
  /* 글자 색 */
  font-size: 1rem;
  /* 글자 크기 */
  font-weight: bold;
  /* 글자 두께 */
  background-color: rgba(255, 255, 255, 1);
  /* 반투명 배경 */
  border-radius: 20px !important;
  /* 배경의 모서리를 둥글게 */
  height: 30px !important;
  width: 30px !important;
  padding: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}

.closed {
  position: absolute;
  top: -5px;
  /* 이미지 위에서의 위치 */
  right: 5px;
  /* 이미지 왼쪽에서의 위치 */
  color: #8d8d8d;
  /* 글자 색 */
  font-size: 0.8rem;
  /* 글자 크기 */
  font-weight: bold;
  /* 글자 두께 */
  z-index: 10;
  font-family: var(--font-noto-b);
  background-color: rgba(255, 255, 255, 1);
  /* 반투명 배경 */
  padding: 1px 4px 2px 4px;
  /* 배경과 글씨 사이의 여백 */
  border-radius: 5px;
  /* 배경의 모서리를 둥글게 */
  line-height: 18px;
}

.ddayLabel {
  position: absolute;
  top: -5px;
  /* 이미지 위에서의 위치 */
  right: 5px;
  /* 이미지 왼쪽에서의 위치 */
  color: white;
  /* 글자 색 */
  font-size: 0.9rem;
  /* 글자 크기 */
  font-weight: bold;
  /* 글자 두께 */
  font-family: var(--font-noto-b);
  background: linear-gradient(45deg,
      #007bff,
      #0056b3);
  /* 파란색 그라데이션 배경 */
  padding: 2px 4px;
  /* 배경과 글씨 사이의 여백 */
  border-radius: 5px;
  /* 배경의 모서리를 둥글게 */
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.4);
  /* 파란색 그림자 */
  animation: ddayLabelPulse 1.5s ease-in-out infinite;
  z-index: 10;
  line-height: 18px;
}

@keyframes ddayLabelPulse {

  0%,
  100% {
    box-shadow: 0 2px 8px rgba(0, 123, 255, 0.4);
    transform: scale(1);
  }

  50% {
    box-shadow: 0 4px 16px rgba(0, 123, 255, 0.6);
    transform: scale(1.05);
  }
}

.draftLabel {
  position: absolute;
  top: -5px;
  /* 이미지 위에서의 위치 */
  right: 5px;
  /* 이미지 오른쪽에서의 위치 */
  color: white;
  /* 글자 색 */
  font-size: 0.8rem;
  /* 글자 크기 */
  font-weight: bold;
  /* 글자 두께 */
  font-family: var(--font-noto-b);
  background: linear-gradient(45deg,
      #6c757d,
      #495057);
  /* 회색 그라데이션 배경 */
  padding: 2px 4px;
  /* 배경과 글씨 사이의 여백 */
  border-radius: 5px;
  /* 배경의 모서리를 둥글게 */
  box-shadow: 0 2px 8px rgba(108, 117, 125, 0.4);
  /* 회색 그림자 */
  animation: draftLabelPulse 2s ease-in-out infinite;
  z-index: 10;
  line-height: 18px;
}

@keyframes draftLabelPulse {

  0%,
  100% {
    box-shadow: 0 2px 8px rgba(108, 117, 125, 0.4);
    transform: scale(1);
  }

  50% {
    box-shadow: 0 4px 16px rgba(108, 117, 125, 0.6);
    transform: scale(1.05);
  }
}

.pendingLabel {
  position: absolute;
  top: -5px;
  /* 이미지 위에서의 위치 */
  right: 5px;
  /* 이미지 오른쪽에서의 위치 */
  color: white;
  /* 글자 색 */
  font-size: 0.8rem;
  /* 글자 크기 */
  font-weight: bold;
  /* 글자 두께 */
  font-family: var(--font-noto-b);
  background: linear-gradient(45deg,
      #ff6b35,
      #f7931e);
  /* 주황색 그라데이션 배경 */
  padding: 2px 4px;
  /* 배경과 글씨 사이의 여백 */
  border-radius: 5px;
  /* 배경의 모서리를 둥글게 */
  box-shadow: 0 2px 8px rgba(255, 107, 53, 0.4);
  /* 주황색 그림자 */
  animation: pendingLabelPulse 2s ease-in-out infinite;
  z-index: 10;
  line-height: 18px;
}

@keyframes pendingLabelPulse {

  0%,
  100% {
    box-shadow: 0 2px 8px rgba(255, 107, 53, 0.4);
    transform: scale(1);
  }

  50% {
    box-shadow: 0 4px 16px rgba(255, 107, 53, 0.6);
    transform: scale(1.05);
  }
}

.endedOverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  /* 검은색 반투명 오버레이 */
  border-radius: 10px;
  /* 이미지와 동일한 둥근 모서리 */
  pointer-events: none;
  /* 클릭 이벤트가 통과하도록 */
}

.ddayGlow {
  animation: ddayPulse 2s ease-in-out infinite;
  box-shadow: 0 0 12px rgba(0, 123, 255, 0.5), 0 0 24px rgba(0, 123, 255, 0.3);
  border-radius: 10px;
  transition: all 0.3s ease;
}

.ddayGlow:hover {
  box-shadow: 0 0 18px rgba(0, 123, 255, 0.7), 0 0 36px rgba(0, 123, 255, 0.5);
  transform: scale(1.01);
}

@keyframes ddayPulse {

  0%,
  100% {
    box-shadow: 0 0 12px rgba(0, 123, 255, 0.5), 0 0 24px rgba(0, 123, 255, 0.3);
  }

  50% {
    box-shadow: 0 0 18px rgba(0, 123, 255, 0.7), 0 0 36px rgba(0, 123, 255, 0.5);
  }
}

.linkookGlow {
  animation: linkookPulse 2s ease-in-out infinite;
  box-shadow: 0 0 12px rgba(102, 189, 255, 0.5),
    0 0 24px rgba(255, 105, 180, 0.3);
  border-radius: 10px;
  transition: all 0.3s ease;
}

.linkookGlow:hover {
  box-shadow: 0 0 18px rgba(102, 189, 255, 0.7),
    0 0 36px rgba(255, 105, 180, 0.5);
  transform: scale(1.01);
}

@keyframes linkookPulse {

  0%,
  100% {
    box-shadow: 0 0 12px rgba(102, 189, 255, 0.5),
      0 0 24px rgba(255, 105, 180, 0.3);
  }

  50% {
    box-shadow: 0 0 18px rgba(102, 189, 255, 0.7),
      0 0 36px rgba(255, 105, 180, 0.5);
  }
}

.linkookLabel {
  position: absolute;
  top: -5px;
  left: 5px;
  color: white;
  font-size: 0.8rem;
  font-weight: bold;
  font-family: var(--font-noto-b);
  background: linear-gradient(45deg, #66bdff, #ff69b4);
  padding: 2px 4px;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(102, 189, 255, 0.4);
  animation: linkookLabelPulse 2s ease-in-out infinite;
  z-index: 10;
  line-height: 18px;
}

@keyframes linkookLabelPulse {

  0%,
  100% {
    box-shadow: 0 2px 8px rgba(102, 189, 255, 0.4);
    transform: scale(1);
  }

  50% {
    box-shadow: 0 4px 16px rgba(102, 189, 255, 0.6);
    transform: scale(1.05);
  }
}

a {
  padding: 0px;
}

/* 팝업 스타일 */
.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 80%;
  width: 80%;
  height: 90%;
  max-height: 90%;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  z-index: 20;
  text-align: center;
  margin: auto;
  overflow-y: scroll;
}

.blank {
  height: 10px;
}

button {
  padding: 0px;
  background-color: transparent;
  border: none;
}

/* 달력 뷰 스타일 */
.calendarContainer {
  width: 90%;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  padding: 10px;
  padding-top: 0px;
}

.calendarInfoBanner {
  position: relative;
  display: block;
  background: #f8fbff;
  border: 1.5px solid #d0e8ff;
  border-radius: 12px;
  padding: 14px 18px;
  margin-bottom: 16px;
  text-decoration: none;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.25s ease;
}

.calendarInfoBanner:hover {
  transform: translateY(-2px);
  border-color: #66bdff;
  box-shadow: 0 6px 20px rgba(102, 189, 255, 0.15);
  background: #f0f8ff;
}

.calendarInfoGlow {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 10% 50%, rgba(102, 189, 255, 0.07) 0%, transparent 60%);
  pointer-events: none;
}

.calendarInfoContent {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 12px;
}

.calendarInfoIcon {
  width: 38px;
  height: 38px;
  min-width: 38px;
  border-radius: 50%;
  background: #66bdff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  box-shadow: 0 2px 8px rgba(102, 189, 255, 0.3);
  animation: calIconBounce 2.2s ease-in-out infinite;
}

@keyframes calIconBounce {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-3px);
  }
}

.calendarInfoText {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.calendarInfoTitle {
  font-size: 0.875rem;
  font-weight: 700;
  color: #1a1a1a;
  font-family: "NanumSquareRoundB", sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.calendarInfoSub {
  font-size: 0.72rem;
  color: #888;
  font-family: "NanumSquareRoundR", sans-serif;
}

.calendarInfoBadge {
  flex-shrink: 0;
  background: #66bdff;
  color: #fff;
  padding: 5px 13px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
  font-family: "NanumSquareRoundB", sans-serif;
  white-space: nowrap;
}

.calendarHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.navButton {
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 20px;
  color: #333;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.navButton:hover {
  background: #e0e0e0;
}

.monthTitle {
  font-size: 1.25rem;
  font-weight: bold;
  color: #222;
  margin: 0;
  font-family: "NanumSquareRoundB", sans-serif;
}

.calendarWrapper {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.weekdayHeader {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0;
  padding: 6px 0 10px;
  border-bottom: 1px solid #e5e7eb;
}

.weekday {
  text-align: center;
  font-size: 0.8rem;
  font-weight: 600;
  color: #888;
  font-family: "NanumSquareRoundB", sans-serif;
}

.weekday:first-child {
  color: #ff5c5c;
}

.calendarGrid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0;
}

.calendarDay {
  height: 220px;
  border: none;
  border-bottom: 1px solid #f0f0f0;
  padding: 8px 4px 6px;
  cursor: pointer;
  transition: background 0.15s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: #fff;
  overflow: hidden;
}

.calendarDay:hover {
  background: #f7f9ff;
}

.calendarDay.otherMonth {
  background: #fafafa;
}

.calendarDay.otherMonth .dayNumber {
  color: #ccc;
}

.calendarDay.sunday .dayNumber {
  color: #ff5c5c;
}

.calendarDay.sunday.otherMonth .dayNumber {
  color: #ffb3b3;
}

/* 날짜 숫자 래퍼 */
.dayNumberWrap {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-bottom: 4px;
  flex-shrink: 0;
}

.dayNumberWrap.todayBadge {
  background: #1a1a1a;
}

.dayNumberWrap.todayBadge .dayNumber {
  color: #fff !important;
}

.dayNumber {
  font-size: 0.8rem;
  color: #333;
  font-weight: 600;
  font-family: "NanumSquareRoundB", sans-serif;
  line-height: 1;
}

/* 원형 포스터 모음 */
.circlePosters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 2px;
  margin-bottom: 4px;
  width: 100%;
}

.circlePoster {
  width: 26px;
  height: 26px;
  min-width: 18px;
  border-radius: 30px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #e0e0e0;
}

.circlePosterPlaceholder {
  background-color: #d1d5db;
}

.morePosters {
  font-size: 0.5rem;
  font-weight: 700;
  color: #888;
  line-height: 18px;
  padding-left: 1px;
}

/* 이벤트 목록 */
.calendarDayEvents {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
}

/* 이벤트 pill */
.calendarEventPill {
  width: 100%;
  font-size: 0.5rem;
  font-weight: 700;
  font-family: "NanumSquareRoundB", sans-serif;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 5px;
  padding: 2px 4px;
  line-height: 1.5;
}

/* 타입별 pill 색상 */
/* 타입별 pill 색상 — 사이트 메인 컬러(#66bdff, #ff69b4) 기반 */
.eventType__vocal {
  background: #ff69b4;
  /* 핫핑크 — 보컬 */
}

.eventType__band {
  background: #66bdff;
  /* 하늘파랑 — 밴드 */
}

.eventType__dance {
  background: #ffd84d;
  color: #7a5800;
}

.eventType__mix {
  background: linear-gradient(90deg, #66bdff, #ff69b4);
  /* 그라디언트 — 혼합 */
}

.eventType__default {
  background: #b0d8f5;
  /* 연하늘 — 기타 */
  color: #1a5f8a;
}

.eventCount {
  font-size: 0.625rem;
  color: #66bdff;
  font-weight: bold;
  margin-top: 2px;
  font-family: "NanumSquareRoundB", sans-serif;
}

.selectedDateEvents {
  margin-top: 32px;
  padding-top: 24px;
}

.selectedDateTitle {
  font-size: 1.125rem;
  font-weight: bold;
  color: #222;
  margin: 0 0 16px 0;
  font-family: "NanumSquareRoundB", sans-serif;
}

.eventsList {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}


/* 페이지네이션 스타일 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
  gap: 6px;
  flex-wrap: wrap;
}

.pageButton {
  padding: 6px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #ffffff;
  color: #666;
  font-size: 0.8125rem;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 32px;
  text-align: center;
}

.pageButton:hover:not(.activePage):not(:disabled) {
  background: #f8f9fa;
  border-color: #ccc;
  color: #333;
}

.pageButton:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  color: #ccc;
  background: #f8f9fa;
}

.activePage {
  background: #222;
  color: #ffffff;
  border-color: #222;
}

.pageEllipsis {
  padding: 0 8px;
  color: #999;
  font-size: 0.875rem;
}

/* 스켈레톤 UI 스타일 */
.skeletonContainer {
  width: 100%;
}

.skeletonTiles {
  margin: auto;
  padding: 10px;
  width: 90%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.skeletonItem {
  box-sizing: border-box;
  min-width: 0;
  animation: skeletonPulse 1.5s ease-in-out infinite;
}

.skeletonImage {
  width: 100%;
  aspect-ratio: 2896 / 4096;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  border-radius: 10px;
  margin-bottom: 8px;
  animation: skeletonShimmer 2s infinite;
}

.skeletonTitle {
  width: 100%;
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  border-radius: 4px;
  margin-bottom: 6px;
  animation: skeletonShimmer 2s infinite;
}

.skeletonDate {
  width: 100%;
  height: 12px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  border-radius: 4px;
  margin-bottom: 8px;
  animation: skeletonShimmer 2s infinite;
}

.skeletonLineup {
  width: 100%;
  display: flex;
  gap: 4px;
  margin-bottom: 10px;
}

.skeletonPill {
  width: 50px;
  height: 12px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  border-radius: 6px;
  animation: skeletonShimmer 2s infinite;
}

@keyframes skeletonShimmer {
  0% {
    background-position: -200px 0;
  }

  100% {
    background-position: calc(200px + 100%) 0;
  }
}

@keyframes skeletonPulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.7;
  }
}

/* Floating 버튼 스타일 */
.floatingButton {
  position: fixed;
  right: calc(50% - 500px);
  max-width: 1024px;
  margin-right: 12px;
  height: 46px;
  padding: 0px 12px;
  border-radius: 30px;
  background: #66bdff;
  color: white;
  border: none;
  box-shadow: 0 4px 16px rgba(102, 189, 255, 0.4);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 199;
  font-size: 1rem;
  font-weight: bold;
  font-family: "NanumSquareRoundB", sans-serif !important;
  transition: all 0.3s ease;
  bottom: 80px !important;
}

@media screen and (max-width: 1024px) {
  .floatingButton {
    right: 12px;
  }
}

.floatingButton:hover {
  background: #4a9eff;
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(102, 189, 255, 0.6);
}

.floatingButton:active {
  transform: scale(0.95);
}

.commentLikeRow {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 2px;
  margin-bottom: 2px;
}

.commentCount {
  font-size: 0.8125rem;
  color: #888;
}

.likeSection {
  display: flex;
  align-items: center;
  font-size: 0.8125rem;
  gap: 4px;
}

.likeBtn {
  background: none;
  border: none;
  color: #bbb;
  font-size: 1.125rem;
  cursor: pointer;
  padding: 0 4px;
  transition: color 0.15s;
}

.likeBtn.liked {
  color: #ff4b4b;
}

.likeBtn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.selected {
  background-color: #222 !important;
  border-radius: 50% !important;
  transition: background 0.15s;
  padding: 5px !important;
}

/* ========================================
   반응형 디자인
   - Medium: 481px ~ (기본 스타일, 최대 1024px)
   - Small: ~480px
   ======================================== */

/* ========================================
   Small (~480px): 2컬럼
   ======================================== */
@media screen and (max-width: 480px) {

  .marqueeContainer {
    width: 90%;
    padding: 5px;
    height: 25px;
    margin-bottom: 5px;
  }

  .marqueeItem {
    font-size: 0.625rem;
    margin-right: 20px;
  }

  /* 금주의 라이브 모바일 */
  .weeklySection {
    width: 90%;
    margin: 8px auto 0 auto;
    padding: 8px 0;
  }

  .weeklySectionHeader {
    margin-bottom: 8px;
    padding: 0 0px;
  }

  .weeklySectionTitle {
    font-size: 0.875rem;
  }

  .weeklyCards {
    gap: 12px;
    padding: 0 0px 8px 0px;
  }

  .weeklyCard {
    width: calc((100% - 12px) / 2);
    min-width: 120px;
    max-width: 160px;
  }

  .weeklyImgDiv {
    border-radius: 8px;
  }

  .weeklyImgDiv img {
    border-radius: 8px;
  }

  .weeklyDate {
    font-size: 0.7rem;
    padding-top: 2px;
  }

  .weeklyTitle {
    font-size: 0.875rem;
    padding-top: 1px;
  }

  .weeklyImagePlaceholder .placeholderIcon {
    font-size: 1.8rem;
  }

  .syncButton {
    width: 30px;
    height: 30px;
    padding: 5px;
    border-radius: 6px;
  }

  .syncIcon {
    width: 18px;
    height: 18px;
  }

  .dateFilterButton {
    width: 30px;
    height: 30px;
    padding: 5px;
    border-radius: 6px;
  }

  .calendarIcon {
    width: 18px;
    height: 18px;
  }

  .calendarDay {
    padding: 0px;
  }

  .dateFilterDropdown {
    width: 260px;
    left: 0;
  }

  .dateFilterHeader {
    padding: 10px 14px;
  }

  .dateFilterTitle {
    font-size: 0.875rem;
  }

  .dateFilterBody {
    padding: 12px;
    gap: 10px;
  }

  .dateFilterLabel {
    font-size: 0.75rem;
    width: 32px;
  }

  .customSelect {
    padding: 7px 8px;
    font-size: 0.75rem;
    border-radius: 5px;
  }

  .customSelectOption {
    padding: 7px 8px;
    font-size: 0.75rem;
  }

  .customSelectOptions {
    max-height: 150px;
  }

  .dateFilterFooter {
    padding: 10px 12px;
    gap: 6px;
  }

  .dateFilterReset,
  .dateFilterApply {
    padding: 9px;
    font-size: 0.75rem;
    border-radius: 6px;
  }

  .tiles {
    padding: 10px 0px;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .title {
    font-size: 0.955rem;
  }

  .date {
    font-size: 0.7rem;
  }

  .place {
    font-size: 0.625rem;
    padding-top: 2px;
  }

  .lineup {
    height: 20px;
  }

  .lineupPill {
    font-size: 0.65rem;
    padding: 1px 5px;
    line-height: 13px;
  }

  .lineupPill_one {
    font-size: 0.65rem;
    padding: 1px 5px;
    line-height: 13px;
  }

  .lineupMarquee {
    height: 15px;
  }

  .dayCount {
    font-size: 0.7rem;
    padding: 2px 4px;
    line-height: 13px;
  }

  .liveType {
    width: 22px !important;
    height: 22px !important;
    padding: 3px;
  }

  .likeHeart {
    width: 22px !important;
    height: 22px !important;
    padding: 3px;
  }

  .likeBtnOverlay {
    bottom: 5px;
    right: 5px;
  }

  .closed {
    font-size: 0.7rem;
    padding: 1px 4px 2px 4px;
    line-height: 13px;
  }

  .ddayLabel {
    font-size: 0.6rem;
    padding: 2px 4px;
    line-height: 13px;
  }

  .draftLabel {
    font-size: 0.6rem;
    padding: 2px 4px;
    line-height: 13px;
  }

  .pendingLabel {
    font-size: 0.6rem;
    padding: 2px 4px;
    line-height: 13px;
  }

  .linkookLabel {
    font-size: 0.6rem;
    padding: 2px 4px;
    line-height: 13px;
  }

  .placeholderIcon {
    font-size: 2rem;
    margin-bottom: 8px;
  }

  .posterLoadingIcon {
    font-size: 1.75rem;
  }

  .placeholderText {
    font-size: 0.75rem;
    padding: 0 8px;
  }

  .popup {
    max-width: 90%;
    width: 90%;
  }

  /* 필터/검색 반응형 */
  .controls {
    padding: 0px;
    gap: 8px;
  }

  .typeFilter {
    gap: 6px;
  }

  .typeButton {
    padding: 6px 12px;
    font-size: 0.75rem;
  }

  .activeType {
    background: #222;
    color: white;
    border-color: #222;
  }

  .likeButton {
    padding: 4px 6px;
  }

  .likeButton:active {
    background: #ff6b9d;
    border-color: #ff6b9d;
  }

  .likeIcon {
    width: 18px;
    height: 18px;
  }

  .searchInput {
    height: 31px !important;
    font-size: 0.75rem;
  }

  .sortButton {
    padding: 8px 10px;
    font-size: 0.75rem;
  }

  .sortButton:hover {
    background: #222;
  }

  .sortIcon {
    width: 14px;
    height: 14px;
  }

  /* 데스크톱 전용 버튼 숨김 */
  .desktopOnly {
    display: none !important;
  }

  .blank {
    height: 5px;
  }

  /* 스켈레톤 */
  .skeletonTiles {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    padding: 10px 0px;
  }

  .skeletonTitle {
    height: 12px;
  }

  .skeletonDate {
    height: 10px;
  }

  /* 페이지네이션 */
  .pagination {
    gap: 4px;
    margin-top: 18px;
  }

  .pageButton {
    padding: 5px 8px;
    font-size: 0.6875rem;
    min-width: 26px;
    border-radius: 5px;
  }

  /* 달력 뷰 반응형 */
  .calendarContainer {
    width: 90%;
    padding: 0px;
  }

  .calendarHeader {
    width: 90%;
    margin: auto;
    margin-bottom: 16px;
  }

  .circlePoster {
    width: 18px;
    height: 18px;
    border-radius: 25px;
  }

  .monthTitle {
    font-size: 1rem;
  }

  .calendarWrapper {
    gap: 4px;
  }

  .weekdayHeader {
    gap: 4px;
  }

  .weekday {
    font-size: 0.75rem;
    padding: 4px;
  }

  .calendarGrid {
    gap: 4px;
  }

  .dayNumber {
    font-size: 0.75rem;
  }

  .eventCount {
    font-size: 0.5rem;
  }

  .eventsList {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    padding: 10px 0px;
  }

  .selectedDateTitle {
    font-size: 1rem;
  }

  .selectedDateEvents {
    margin-top: 20px;
    padding-top: 16px;
  }
}
</style>
